import React, { Component } from 'react';
import propTypes from 'prop-types';
;
import { Button, Columns, Column, MuiTitle, Container, Field as BulmaField, Content } from 'src/ui/mui-ui-kit';;;
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { withNavigation } from 'src/ui/hoc';
import { SolventLogo, UiSelectAdapter, InnerLoader } from 'src/ui';
import { required, composeValidators } from 'src/ui/validations';
import { getUser, fetchLoggedInUser } from 'src/user';
import { setSelectedAccount } from '../redux';
import { AsideCard } from '../components';

class AccountSelectionPage extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    const { user } = this.props;

    if (user.accounts.length === 1) {
      this.handleSubmit({ account: user.accounts[0] });
    }
  }

  handleSubmit = async ({ account }) => {
    const { setSelectedAccount, fetchLoggedInUser, history } = this.props;

    this.setState({ loading: true });

    await setSelectedAccount(account.id);
    await fetchLoggedInUser();
    history.push('/');
  };

  render() {
    const { user } = this.props;
    const { loading } = this.state;
    return (
      <>
        <Container className="create-password">
          <Form
            onSubmit={this.handleSubmit}
            render={({ handleSubmit, submitting, hasValidationErrors }) => (
              <form onSubmit={handleSubmit}>
                <Columns
                  className="create-password-form"
                >
                  <Column>
                    <div className="left-column">
                      <SolventLogo />

                      <MuiTitle isSize={6} tag="h2" hasTextColor="secondary">
                        Select Account
                      </MuiTitle>

                      <Field
                        component={UiSelectAdapter}
                        name="account"
                        id="account"
                        label="Account"
                        required
                        validate={composeValidators('Account', required)}
                        options={user.accounts}
                        getOptionLabel={item =>
                          `${item.name} ${item.financialInstitution
                            ? `- ${item.financialInstitution.businessName}`
                            : ''
                          }`
                        }
                        getOptionValue={item => item.id}
                        hideAsterisk
                      />

                      <BulmaField>
                        <Button
                          isColor="gradient-bright"
                          className="is-long"
                          disabled={submitting || hasValidationErrors}
                          isLoading={submitting}
                          type="submit"
                        >
                          Confirm
                        </Button>
                      </BulmaField>
                    </div>
                  </Column>
                  <Column className="right-column">
                    <AsideCard>
                      <Content className="has-text-grey-medium-dark">
                        <p>
                          Your user is linked to multiple accounts. Select one to
                          connect to from the dropdown on the left.
                        </p>
                        <p>
                          It is possible to switch accounts later through your
                          user menu.
                        </p>
                      </Content>
                    </AsideCard>
                  </Column>
                </Columns>
              </form>
            )}
          />
        </Container>
        <InnerLoader visible={loading} />
      </>
    );
  }
}

AccountSelectionPage.propTypes = {
  history: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  setSelectedAccount: propTypes.func.isRequired,
  fetchLoggedInUser: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

const connectedAccountSelectionPage = connect(mapStateToProps, {
  setSelectedAccount,
  fetchLoggedInUser,
})(withNavigation(AccountSelectionPage));

export { connectedAccountSelectionPage as AccountSelectionPage };
